/**
 * @module Form
 */
(function Form() {

    /**
     * Interaction handling for a form element which is has the possibility to appear multiple
     *
     * Minimal API:
     * <div data-tdform-multiplicity="mySelector">
     *      <div data-tdform-multiplicity="element">
     *         <input type="text" name="myValues[0]"/>
     *         <div class="panel-footer panel-footer-actions" data-tdform-multiplicity="actions">
     *             <span data-tdform-multiplicity="delete">Delete</span>
     *             <span data-tdform-multiplicity="add">Add</span>
     *         </div>
     *     </div>
     * </div>
     *
     * $('[data-tdform-multiplicity="mySelector"]').each(function(idx, element) {
     *       var myMultiplicity = new TechDivisionForm.Multiplicity($(element));
     * });
     *
     *
     * @class Multiplicity
     * @param {jQuery} domContainer The container of the elements
     * @param {object} options Adjust the default options if given. See options property for more info
     * @constructor
     */
    function Multiplicity(domContainer, options) {
        // context
        var _this = this;
        // selector for a single element
        var elementSelector = '[data-tdform-multiplicity="element"]';
        // selector for a wrapper around the actions
        var actionsSelector = '[data-tdform-multiplicity="actions"]';
        // delete action selector
        var deleteActionSelector = '[data-tdform-multiplicity="delete"]';
        // add action selector
        var addActionSelector = '[data-tdform-multiplicity="add"]';

        /**
         * Default options which get merged with given options by construction
         * @property options
         * @type {{allowDeleteFirst: boolean, initialEmpty: boolean, specialElementRendering: Multiplicity.options.specialElementRendering, elementWillBeRemoved: Multiplicity.options.elementWillBeRemoved}}
         */
        this.options = {
            // allows to deletion of the first element
            allowDeleteFirst: false,
            // takes care the first element of initial rendering will be removed after the prototype got cloned
            initialEmpty: false,
            // (Optional) Gets called for each element on rendering. 1. param is the element as jQuery dom object itself and current number of element
            specialElementRendering: function() {},
            // Gets called right before an element will be removed
            elementWillBeRemoved: function(element, isLast) {}
        };
        if(options) {
            $.extend(true, this.options, options);
        }

        /**
         * The container around
         * @type {jQuery} dom
         */
        var container = domContainer;

        /**
         * The element dom prototype for cloning
         * @type {jQuery} dom
         */
        var elementPrototype = container.find(elementSelector).clone();

        /**
         * Builds a new element with the given index. The index is important for name of the input fields
         * @param {integer} number
         * @returns {jQuery} Dom object
         */
        this.buildNewElement = function(number) {
            var element = elementPrototype.clone();
            // replace the name with given index number
            //var inputElements = element.querySelectorAll();
            element.find('input,select').each(function(idx, element){
                $(element).attr('name', $(element).attr('name').replace("[0]", "[" + number + "]"));
            });

            _this.bindEvents(element, number);
            return element;
        };

        /**
         * Removes the given element, shows the actions of the new last element
         * @api
         * @param {jQuery} element Dom object
         */
        this.delete = function(element) {
            _this.options.elementWillBeRemoved(element, container.find(elementSelector).length == 1);
            // show the second elements actions
            container.find(elementSelector).eq(-2).find(actionsSelector).slideDown();
            element.slideUp(400, function(){
                element.remove();
            });
        };

        /**
         * Adds a new element, hides the actions of second last element
         * @api
         * @returns {jQuery} The added element
         */
        this.add = function() {
            var amountElements = container.children().length;
            var newElement = _this.buildNewElement(amountElements);
            newElement.hide();
            var potentialSecondLastElement =  container.find(elementSelector).last();
            if(potentialSecondLastElement) {
                potentialSecondLastElement.find(actionsSelector).slideUp();
            }
            newElement.appendTo(container);
            newElement.slideDown();
            return newElement;
        };

        /**
         * Binds the events to the action elements
         */
        this.bindEvents = function(element, number) {
            element.find(deleteActionSelector).click(function() {
                _this.delete($(this).parents(elementSelector));
            });
            element.find(addActionSelector).click(function() {
                _this.add();
            });
            this.options.specialElementRendering(element, number);
        };

        // depending on configuration
        if(this.options.initialEmpty) {
            container.find(elementSelector).remove();
        } else {
            var number = 1;
            this.bindEvents(container.find(elementSelector), number);
            // remove delete action for first element after prototype cloning
            if(!this.options.allowDeleteFirst) {
                container.find(elementSelector).find(deleteActionSelector).remove();
            }
        }
    }

    // export api
    if(typeof window.TechDivisionForm === 'undefined') {
        window.TechDivisionForm = {};
    }
    window.TechDivisionForm.Multiplicity = Multiplicity;
})();



